// extracted by mini-css-extract-plugin
export const keyvisual = "keyvisual-module--keyvisual--Vgtz5";
export const fullsize = "keyvisual-module--fullsize--19QK4";